import { Dashboard } from 'containers/Dashboard'

export default Dashboard
